export const PROFILE_FIELDS = `
  fragment profileFields on Profile {
    _id
    firstName
    lastName
    email
    mobile
    teams
    dateOfBirth
    countryOfBirth
    height
    weight
    position
    jerseyNumber
    userId
    photo
    preferredFoot
    targetClub
    roleModel
    favouriteBrand
    boots
    instagram
    tiktok
    skills {
      first
      second
	    third
    }
  }
`;

export const GET_PROFILES = `
  ${PROFILE_FIELDS}
  query ($term: String, $clubId: String, $teamId: String, $playerIds: [String], $skip: Int, $limit: Int, $sortingDir: String, $sortingField: String) {
    getPlayers(term: $term, clubId: $clubId, teamId: $teamId, playerIds: $playerIds, skip: $skip, limit: $limit, sortingDir: $sortingDir, sortingField: $sortingField) {
      ...profileFields
    }
  }
`;
